// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2dBJp","h2":"Title_h2__1NJ_V","p":"Title_p__3yuAJ","title-heading":"Title_title-heading__kLmLm","title-subheading":"Title_title-subheading__1qQbb"};